import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";

export function useLocationById(locationId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["locationById", locationId],
    queryFn: async () => {
      if (locationId) return await apiContext.locationApis.getLocationById(locationId);
    },
  });
}
